import React, {useEffect} from 'react'

import './StadePage.scss'
import {useNavigate, useParams, useSearchParams} from "react-router-dom";
import {useDispatch} from "react-redux";
import {setDoor} from "../../store/actions";
import {DoorModel} from "../../Models/DoorModel";
import powered from '../../Assets/Icons/powered.svg'
import Error from "../../Components/Error/Error";
import {useError} from "../../hooks/useError";
import {useGetEvent} from "../../hooks/useGetEvent";
import coubertin from "../../Assets/Logos/coubertin.svg";
import plenitude from "../../Assets/Logos/plenitude.svg";
//import matmut from "../../Assets/Logos/matmut.svg";
import bordeaux from "../../Assets/Logos/bordeaux.png";
import mauroy from "../../Assets/Logos/losc.png";
import parisSaintGermain from "../../Assets/Logos/parisSaintGermain.svg";
import rolandGarros from "../../Assets/Logos/rolandGarros.svg";
import {useTranslation} from "react-i18next";

interface LogoModel {
  image: string,
  reference: string
  size?: {width: string, height: string}
}

const stadesImages: LogoModel[] = [
  { reference: 'PDC', image: coubertin},
  { reference: 'PAR', image: plenitude, size: {width: "500px", height: "500px"}},
  { reference: 'BMA', image: bordeaux},
  { reference: 'LIL', image: mauroy},
  { reference: 'PDP', image: parisSaintGermain},
  { reference: 'RGP', image: rolandGarros},
]


const StadePage: React.FC = ({}) => {
  const {t} = useTranslation(['common'])
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const {stadium} = useParams()
    const [searchParams,] = useSearchParams();
    const eventError = useError()
    const apiError = useError()
    const getEvent = useGetEvent(() => eventError.open(""), () => apiError.open(""))

    useEffect(() => {
      setTimeout(() => {
        getEvent(
          stadium,
          (doors: DoorModel[]) => {
            const doorId = searchParams.get("door")
            const pdvId = searchParams.get("pdv")
            if(doorId) {
              dispatch(setDoor(doors.find((d: DoorModel) => d.id.toString() === doorId)))
              navigate(`/stands?stadium=${stadium}&doorId=${doorId}`)
            } else if(pdvId) {
              dispatch(setDoor(undefined))
              navigate(`/menu?stadium=${stadium}&pdvId=${pdvId}`)
            } else {
              navigate(`/choixporte?stadium=${stadium}`)
            }
          }
        )
      }, 2500)
    }, [])

    const getSize = () => {
        return stadesImages.find(it => it.reference === stadium)?.size
    }

    return (
        <>
            <div className="homePage">
                <img src={stadesImages.find(it => it.reference === stadium)?.image ?? ''} className="homePage--logo" style={getSize() && {width: getSize()?.width, height: getSize()?.height}}/>
                <img src={powered} className="homePage--powered"/>
            </div>
          <Error show={eventError.visible} title={t('common:errors.noEvent.title')}
                 subTitle={t('common:errors.noEvent.subtitle')}/>
          <Error show={apiError.visible} title={t('common:errors.serviceUnavailable.title')}
                 subTitle={t('common:errors.serviceUnavailable.subtitle')}/>
        </>
    )
}

export default StadePage;
